import { Link, NavLink } from "react-router-dom";
import { ShoppingBasket, Truck, PackageSearch, Gift } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useMeta } from "@/lib/useMeta";
import { gbp } from "@/lib/api";
import { ChristmasBanner } from "@/components/ChristmasDeadline";

const navCls = ({ isActive }) =>
  `text-sm font-medium transition-colors hover:text-[#8C2220] ${isActive ? "text-[#8C2220]" : "text-slate-700"}`;

export default function Header() {
  const { count, setOpen } = useCart();
  const meta = useMeta();
  return (
    <header className="sticky top-0 z-40 bg-[#FDFBF7]/90 backdrop-blur-md border-b border-[#E8DFCF]">
      <div className="bg-[#0F172A] text-[#F7F3EB] text-xs py-2 text-center tracking-wide" data-testid="promo-bar">
        <Truck className="inline w-3.5 h-3.5 mr-2 -mt-0.5 text-[#D4AF37]" />
        {meta?.free_over != null ? `Free Evri Standard delivery on orders over ${gbp(meta.free_over)} · ` : ""}Posting all over the UK with Evri
      </div>
      <ChristmasBanner />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap shrink-0" data-testid="logo-link">
          <img src="/logo-mark.png" alt="" className="w-8 h-8 sm:w-11 sm:h-11" data-testid="logo-mark" />
          <span className="font-serif text-lg sm:text-3xl font-bold text-[#1E2A44] tracking-tight">Albion Pantry</span>
          <span className="hidden sm:inline text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">Fine British Food</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          <NavLink to="/" end className={navCls} data-testid="nav-shop">Shop</NavLink>
          {meta?.season_nav && <NavLink to="/gifts" className={navCls} data-testid="nav-seasonal">{meta.season_nav}</NavLink>}
          <NavLink to="/hampers" className={navCls} data-testid="nav-hampers">Hampers</NavLink>
          <NavLink to="/gift-cards" className={navCls} data-testid="nav-giftcards">Gift Cards</NavLink>
          <NavLink to="/delivery" className={navCls} data-testid="nav-delivery">Delivery & Stock</NavLink>
          <NavLink to="/track" className={navCls} data-testid="nav-track">Track order</NavLink>
        </nav>
        <div className="flex items-center gap-1 sm:gap-2">
          {meta?.season_nav && <Link to="/gifts" className="md:hidden p-1.5 sm:p-2" data-testid="nav-seasonal-mobile" aria-label={meta.season_nav}><Gift className="w-5 h-5" /></Link>}
          <Link to="/delivery" className="md:hidden p-1.5 sm:p-2" data-testid="nav-delivery-mobile" aria-label="Delivery"><Truck className="w-5 h-5" /></Link>
          <Link to="/track" className="md:hidden p-1.5 sm:p-2" data-testid="nav-track-mobile" aria-label="Track order"><PackageSearch className="w-5 h-5" /></Link>
          <button
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 rounded-full bg-[#8C2220] text-white pl-4 pr-5 py-2.5 text-sm font-semibold hover:bg-[#701A18] active:scale-95 transition-[background-color,transform]"
            data-testid="open-cart-button"
          >
            <ShoppingBasket className="w-4 h-4" />
            <span className="hidden sm:inline">Basket</span>
            <span className="ml-1 min-w-6 h-6 px-1.5 rounded-full bg-[#D4AF37] text-[#0F172A] text-xs font-bold grid place-items-center" data-testid="cart-count">
              {count}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
